<template>
  <div>
    <v-form ref="sendDocumentForm">
      <v-row>
        <v-col cols="12">
          <v-text-field
              v-model="data.title"
              :rules="[v => !!v || languageData.validateSendEmailForm.title_required]"
              :label="languageData.documents.title"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
              v-model="data.message"
              :label="languageData.documents.message + ' (' + languageData.documents.optional + ')'"
              :rows="1"
          >
          </v-textarea>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-end">
        <div>
          <v-btn
              class="button-shadow"
              color="primary"
              @click="sendEmailDocument"
              :loading="emailIsSending"
          >
            {{ languageData.labels.send }}
          </v-btn>
        </div>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import eventBus from "../../../../event-bus/eventBus";

export default {
  name: "SendDocumentForm",
  props: {
    clientPerson: Object,
  },
  data() {
    return {
      data: {
        title: this.title,
        message: '',
      },
      title: '',
    }
  },
  computed: {
    ...mapState("sendDocument", {
      document: state => state.document,
      emailIsSending: state => state.emailIsSending
    }),
    ...mapState("getProject", {
      project: state => state.dataReceive
    }),
    ...mapState("getClient", {
      client: state => state.dataReceive
    })
  },
  methods: {
    ...mapActions("sendDocument", ["sendDocument"]),
    prepareTitle() {
      return [
          this.languageData.documents.document,
          this.document.type !== null ? this.project ? this.languageData.documentProjectTypes[this.document.type] : this.languageData.documentClientTypes[this.document.type] : '',
          this.languageData.documents.documentFor,
          this.project.name
      ].join(' ');

    },
    sendEmailDocument() {
      if(this.$refs.sendDocumentForm.validate()) {
        this.sendDocument({creds: {
            clientPerson: this.clientPerson,
            document: this.document,
            title: this.data.title,
            message: this.data.message,
          }})
      }
    }
  },
  mounted() {
    this.data.title = this.prepareTitle();
    eventBus.$on('sendDocumentSuccess', () => {
      this.data.message = '';
    });
    eventBus.$on('updateDocumentSuccess', () => {
      this.data.title = this.prepareTitle();
    })
  }
}
</script>
